// =====================================
//
//   Search FAQ Controller
//   Author: Gray
//   createtime: 2016 / 09 / 13
//
// =====================================

window.InifECMobileApp.controller("SearchFAQController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'FAQService',
	function($scope, $state, $timeout, $rootScope, $stateParams, FAQService) {

        // --------------------------------
        // 查詢FAQ
        // --------------------------------
        var getFAQlist = function(){

            if ($scope.isLoading || $scope.isNoMore || $scope.isEmpty) {
                return
            }

            $scope.isLoading = true;

            FAQService.getFAQlist($scope.currentKeyword, $scope.start, $scope.len, $scope.orderby).then(function(result){

                if (Array.isArray(result) && result.length > 0) {

                    for(var i = 0; i < result.length; i++) {
                        var faq = result[i];

                        if($scope.subFaqMap[faq.subFAQClassId] == undefined)  {

                            var subClass = {
                                faqList: [],
                                title: faq.subFAQClassTitle,
                                subFAQClassId: faq.subFAQClassId,
                            }

                            subClass.faqList.push(faq);
                            $scope.subFAQList.push(subClass);

                            $scope.subFaqMap[faq.subFAQClassId] = $scope.subFAQIndex++;
                        } else {
                            var index = $scope.subFaqMap[faq.subFAQClassId];

                            $scope.subFAQList[index].faqList.push(faq);   
                        }
                    }

                    Array.prototype.push.apply($scope.faqList, result);

                    $scope.start += result.length;

                } else if ($scope.faqList.length > 0) {
                    $scope.isNoMore = true;

                } else if ($scope.faqList.length == 0) {
                    $scope.isEmpty = true;
                }

                $scope.isLoading = false;

            }, function (error) {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        };

        // --------------------------------
        // 叫出搜尋bar
        // --------------------------------
        var openSearchBar = function() {

            $scope.isShowSearchBar = true;

            $timeout(function() {
                $('#search-search-input').focus();
            },300);
        }

        // --------------------------------
        // 關閉搜尋bar
        // --------------------------------
        var closeSearchBar = function() {

            $scope.isShowSearchBar = false;
        }

        // --------------------------------
        // 搜尋問題
        // --------------------------------
        var searchFAQ = function(event) {

            if(event) {
                event.preventDefault();
            }

            if($scope.form.keyword) {
                $state.go(window.STATES.SEARCH_FAQ, {
                    keyword: $scope.form.keyword
                });
            }
        }

        var init = function() {
             
        };

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.form = {
            keyword: ''
        };

        $scope.currentKeyword = $stateParams.keyword;
        $scope.faqList = [];
        $scope.subFaqMap = {};
        $scope.subFAQList = [];
        $scope.subFAQIndex = 0;
        $scope.isLoading = false;
        $scope.isEmpty = false;
        $scope.isNoMore = false;
        $scope.isError = false;
        $scope.start = 0;
        $scope.len = 20;
        $scope.orderby = 'subfaqclassid';
        $scope.isShowSearchBar = false;

        //==========================
        //  Methods
        //==========================
        $scope.openSearchBar = openSearchBar;
        $scope.closeSearchBar = closeSearchBar;
        $scope.searchFAQ = searchFAQ;
        $scope.getFAQlist = getFAQlist;
        
        //==========================
        //  Init
        //==========================
        init();
	}
]);